
import { useCallback } from 'react';
import mapboxgl from 'mapbox-gl';

export const useMapMarkers = () => {
  // Helper function to add a marker to the map. useCallback keeps the identity
  // stable so downstream callbacks/effects that depend on it don't re-run every
  // render.
  const addMarkerToMap = useCallback((
    map: mapboxgl.Map,
    coords: [number, number],
    color: string,
    title: string
  ) => {
    const markerEl = document.createElement('div');
    markerEl.style.width = '16px';
    markerEl.style.height = '16px';
    markerEl.style.borderRadius = '50%';
    markerEl.style.backgroundColor = color;
    markerEl.style.border = '2px solid white';
    markerEl.style.boxShadow = '0 0 4px rgba(0,0,0,0.5)';

    new mapboxgl.Marker(markerEl)
      .setLngLat(coords)
      .setPopup(new mapboxgl.Popup().setText(title))
      .addTo(map);
  }, []);

  return {
    addMarkerToMap
  };
};
